import type { TConstraints } from '@feathr/rachis';

import type { IGoogleAdsAdText } from './campaigns';
import type { ICreativeAttributes } from './creatives_base';
import { Creative, CreativeClass } from './creatives_base';

// =============================================================================
// Google Ads Creative Types
// =============================================================================

export interface IGoogleAdsCreative extends ICreativeAttributes {
  readonly _cls: CreativeClass.GoogleAd;
  descriptions: IGoogleAdsAdText[];
  headlines: IGoogleAdsAdText[];
}

// =============================================================================
// Google Ads Creative Class
// =============================================================================

/**
 * GoogleAdsCreative handles Google Ads text creatives.
 * These creatives have headlines and descriptions instead of images/videos.
 */
export class GoogleAdsCreative extends Creative<IGoogleAdsCreative> {
  public readonly className = 'GoogleAdsCreative';

  public override get constraints(): TConstraints<IGoogleAdsCreative> {
    return {};
  }

  public override getDefaults(): Partial<IGoogleAdsCreative> {
    return {
      ...super.getDefaults(),
      _cls: CreativeClass.GoogleAd,
    };
  }
}
